import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './ccf-customer-card.module.scss';
import CcfCustomerProfileInfo from './ccf-customer-card-profile-info/ccf-customer-card-profile-info';
import CcfCustomerAddress from './ccf-customer-card-address/ccf-customer-card-address';
import CcfCustomerContactHistory from './ccf-customer-card-history/ccf-customer-card-history';
import CcfCustomerChannels from './ccf-customer-channels/ccf-customer-channels';
import CcfCustomerNotes from './ccf-customer-notes/ccf-customer-notes';
import {
  activeContactSelector,
  selectAppSpaceActiveIndex,
} from '../ccf-inbox.slice';
import { Direction } from '@mui/material';
import { useTranslator } from '@nice-ccf/ui-controls';
import {
  CcfAllInteraction,
  CcfCurrentInteraction,
  getApplicationDirection,
} from '@nice-ccf/ui-components';

/* eslint-disable-next-line */
export interface CcfCustomerCardProps {}

/**
 * CcfCustomerCard used to disply active contact customer details in the AppSpace
 * @param props --? - CcfCustomerCardProps
 * @example -- <CcfCustomerCard />
 */
export function  CcfCustomerCard(props?: CcfCustomerCardProps) {
  const contactCard = useSelector(activeContactSelector);
  const currentTab = useSelector(selectAppSpaceActiveIndex);
  const dispatch = useDispatch();
  const [translate] = useTranslator();
  const appDirection: Direction = useSelector(getApplicationDirection);

  return contactCard && contactCard.id ? (
    <section className={styles.contactCard}>
      <CcfCustomerProfileInfo />
      <div className={styles.contactDetails}>
        <CcfCustomerAddress />
        <CcfCustomerContactHistory />
        <CcfCustomerChannels />
        <CcfCurrentInteraction />
        <CcfAllInteraction />
        <CcfCustomerNotes />
      </div>
    </section>
  ) : null;
}

export default CcfCustomerCard;
